import { render, staticRenderFns } from "./Metabase.vue?vue&type=template&id=1728d9d6&scoped=true&"
import script from "./Metabase.vue?vue&type=script&lang=js&"
export * from "./Metabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728d9d6",
  null
  
)

export default component.exports